import { api } from './api';

export interface Sincronizacao {
  id: number;
  promotor: string;
  dataString: string;
  tipoComandoString: string;
  tipoEntidadeString: string;
  situacaoSincronizacaoString: string;
}

export interface Tentativa {
  id: number;
  mensagem: string;
  detalhe?: string;
  dataProcessamentoString: string;
  comando: string;
}

export interface TipoSincronizacao {
  Id: number;
  Nome: string;
}

export const sincronizacaoService = {
  // Buscar todas as sincronizações
  getAll: async (): Promise<Sincronizacao[]> => {
    const response = await api.get<Sincronizacao[]>('/api/Sincronizacao/GetAllSincronizacoesTable');
    return response.data;
  },

  // Buscar tentativas por ID da sincronização
  getTentativasByIdSincronizacao: async (id: number): Promise<Tentativa[]> => {
    const response = await api.get<Tentativa[]>(`/api/Sincronizacao/GetTentativasByIdSincronizacao?id=${id}`);
    return response.data;
  },

  // Buscar sincronizações com filtro
  getSincronizacoesComFiltro: async (
    idFuncionario: number | null,
    tipoSincronizacao: number | null,
    dataInicio: string,
    dataFim: string
  ): Promise<Sincronizacao[]> => {
    const response = await api.get<Sincronizacao[]>(
      `/api/Sincronizacao/GetSincronizacoesComFiltro?idFuncionario=${idFuncionario}&tipoSincronizacao=${tipoSincronizacao}&dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return response.data;
  },
};
